import PropTypes from 'prop-types';
import React from 'react';

import AppButton from './AppButton.react';
import importerIcon from '../../img/icons/import.svg';
import tableauIcon from '../../img/icons/reporting.svg';
import exporterIcon from '../../img/icons/export.svg';
import crosschannelIcon from '../../img/icons/crosschannel.svg';

const AppSelector = ({ enabledFeatures }) => (
  <div className='appSelector'>
    {enabledFeatures.reports &&
      <AppButton to='/tableau' icon={tableauIcon} label='Reporting'>
        View Tableau Reports
      </AppButton>
    }
    {enabledFeatures.exporter &&
      <AppButton to='/exporter' icon={exporterIcon} label='Data Exporter'>
        Export the results of a database query to a CSV file
      </AppButton>
    }
    {enabledFeatures.crosschannel &&
      <AppButton to='/crosschannel' icon={crosschannelIcon} label='Cross Channel'>
        Optimize your program for a universe of voters
      </AppButton>
    }
    {enabledFeatures.syncs &&
      <AppButton to='/syncs' icon={crosschannelIcon} label='Sync Status'>
        Check the current status of automated data syncs
      </AppButton>
    }
  </div>
);

AppSelector.propTypes = {
  enabledFeatures: PropTypes.shape({
    importer: PropTypes.bool,
    reports: PropTypes.bool,
    exporter: PropTypes.bool,
    crosschannel: PropTypes.bool,
  }),
};

export default AppSelector;
